exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-bottom{width:100%;height:691px;text-align:center}.about-varoon{height:42px;margin-top:68.6px;font-family:NanumBarunGothicLightOTF;font-size:36px;font-style:normal;font-stretch:normal;letter-spacing:normal;display:inline-block;font-weight:400;color:#000}.core{margin-top:33.4px;background-color:#fcfcfc;height:auto;display:flex;justify-content:center}.core .introduce{width:30%;border-radius:3px;box-shadow:0 0 10px 0 hsla(0,0%,85%,.43);background-color:#fff}.core .introduce:not(:last-child){margin-right:44px}.introduce .num{margin-top:46px;height:32px;font-size:28px;color:#4b74ff}.introduce .name,.introduce .num{font-family:NanumBarunGothicUltraLightOTF;font-style:normal;font-stretch:normal;letter-spacing:normal;text-align:center}.introduce .name{margin-top:17px;height:27px;font-size:24px;color:#000}.introduce img{margin-top:39px;width:100%;object-fit:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20d1094b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/Main.vue
// module id = 101
// module chunks = 0